<template>
    <div>
      <div>
        <hp5-semantic size-selection="xs">
          <input type="checkbox" name="acceptingNewPatients" id="acceptingNewPatients" value="on" v-model="filterContext.acceptingNewPatients" />
          <label for="acceptingNewPatients">Accepting new patients</label>
        </hp5-semantic>
      </div>
    </div>
</template>

<script setup>
      const model = useFCPModel()
      const { filterContext } = model
</script>
  
<style scoped>
  label {
    padding-left: 10px;
  }
</style>